<div class="widget-builder-container">
    <p-tabView [activeIndex]="0" class="reporting-tabview">

        <p-tabPanel header="Tab0" class="p-0">
            <ng-template pTemplate="header">
                <i class="material-icons mr-2 fill">edit_note</i>
                <span>General</span>
            </ng-template>
            <ng-template pTemplate="content">
                <ng-content></ng-content>
            </ng-template>
        </p-tabPanel>

        <p-tabPanel header="Tab1" class="p-0">
            <ng-template pTemplate="header">
                <i class="material-icons mr-2 fill">drive_file_rename_outline</i>
                <span>Html Editor</span>
            </ng-template>
            <ng-template pTemplate="content">
                <div class="html-setup">
                    <div class="grid">
                        <div class="col-6">
                            <div class="html-editor">
                                <widget-html-syntax-tooltip></widget-html-syntax-tooltip>
                                <p-tabView>
                                    <p-tabPanel header="HTML">
                                        <html-editor [(ngModel)]="htmlCode"
                                                     [extensions]="extensions"
                                                     (ngModelChange)="refreshHtmlPreview()">
                                        </html-editor>
                                    </p-tabPanel>
                                    <p-tabPanel header="CSS">
                                        <css-editor [(ngModel)]="cssRules"
                                                    (ngModelChange)="refreshHtmlPreview()">
                                        </css-editor>
                                    </p-tabPanel>
                                </p-tabView>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="html-preview">
                                <h4>Preview</h4>
                                <div class="html-content">
                                    <widget-html [cssInjectionScope]="cssInjectionScopeId"
                                                 [htmlView]="htmlPreview"
                                                 [ignoreDisplayRule]="true">
                                    </widget-html>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </p-tabPanel>
    </p-tabView>
</div>